import { Trans, useTranslation } from 'react-i18next'
import ErrorText from './ErrorText'
import LinkLabel from './LinkLabel'
import { paths } from '../links'
import React from 'react'
import { ErrorCode } from '@linqpal/models/src/types/exceptions'

export const ErrorMessage = ({
  error,
  onPress,
  testID = '',
}: {
  error?: ErrorCode
  onPress?: () => void
  testID?: string
}) => {
  const { t } = useTranslation('errors')
  if (!error) return null
  if (error === 'email-already-in-use') {
    return (
      <ErrorText testID={testID}>
        <Trans i18nKey={error} t={t}>
          This phone number already exists. Click here to
          <LinkLabel
            onPress={onPress}
            screen={paths.Auth.SignIn}
            style={{ fontSize: 15, fontWeight: '600' }}
          >
            login
          </LinkLabel>
        </Trans>
      </ErrorText>
    )
  }
  if (error === 'phone-already-in-use') {
    return (
      <ErrorText testID={testID}>
        <Trans i18nKey={error} t={t}>
          This phone number already exists. Click here to
          <LinkLabel
            onPress={onPress}
            screen={paths.Auth.SignIn}
            style={{ fontSize: 15, fontWeight: '600' }}
          >
            login
          </LinkLabel>
        </Trans>
      </ErrorText>
    )
  }
  return <ErrorText testID={testID}>{t(error)}</ErrorText>
}
